import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IErrorResponse } from '../../interfaces/error-response';

/**
 * Generic popup to show error messages
 */
@Component({
  selector: 'app-error-popup',
  templateUrl: './error-popup.component.html',
  styleUrls: ['./error-popup.component.scss'],
  standalone: false,
})
export class ErrorPopupComponent {
  constructor(
    private dialogRef: MatDialogRef<ErrorPopupComponent>,
    @Inject(MAT_DIALOG_DATA) public data: IErrorResponse
  ) {}

  /**
   * Close dialog
   */
  public close(): void {
    this.dialogRef.close();
  }
}
